import React, { forwardRef } from 'react';

import classNames from 'classnames';

import { NavigationLink, NavigationLinkProps } from '../navigation/NavigationLink';

import './NavigationDropDownLink.scss';

const NavigationDropDownLink = forwardRef<HTMLAnchorElement, NavigationLinkProps>(({ className, ...props }, ref) => {
    if (props.external) {
        return <NavigationLink {...props} ref={ref} className={classNames('nav-dropdown-link', className as string)} />;
    }

    const classNameFunc =
        typeof className === 'function'
            ? (props: { isActive: boolean; isPending: boolean; isTransitioning: boolean }) =>
                  classNames('nav-dropdown-link', className(props))
            : classNames('nav-dropdown-link', className);

    return <NavigationLink {...props} ref={ref} className={classNameFunc} />;
});

export default NavigationDropDownLink;
